import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'What Can I Ship with Ship&Play?',
  description:
    'From suitcases to skis to strollers, Ship&Play makes sending your bags and gear ' +
    'to and from home easy, so you can travel lighter and skip the airport stress.',
  alternates: {
    canonical: 'https://www.shipplay.com/what-can-i-ship',
  },
}

export default metadata
